import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.less']
})
export class ContactusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
